// デフォルト.
import * as React from 'react';
import { BaseBrowser } from './BaseBrowser';
import { Male, Female } from '../../constants/UserListField';
import * as Enumerable from 'linq';
import * as HomeVisit from '../../constants/HomeVisit';

// 居宅訪問チェックシート.
export class Default extends BaseBrowser {
  /**
   * 各項目のJSXの描画その1.
   * @method renderSection1
   * @param {Boolean} isLast 一番最後の行.
   * @param {Boolean} isUpper 上段(true), 下段(false).
   * @param {String|Boolean} titleName 大項目名(falseなら非表示).
   * @param {String} itemName 項目タイトル名.
   * @param {Boolean[]} levels レベルの内容の配列.
   * @param {Boolean} isProblem 課題の有無.
   * @param {String|Boolean} env 環境(実施場所、補助具など)(falseなら下段なので非表示).
   * @param {String|Boolean} detail 状況・生活課題(falseなら1行目ではない).
   * @return {JSX.Element} JSX.
   */
  renderSection1(isLast: boolean, isUpper: boolean, titleName: boolean|string, itemName: string, levels: boolean[],
                 isProblem: boolean, env: boolean|string, detail: boolean|string): JSX.Element {
    const check = (isCheck: boolean): string => {
      return isCheck ? '■' : '□';
    };

    const problem: string = isProblem ? '有' : '無';

    // 下段は「環境(実施場所、補助具など)	」が無いので小さい.
    const titleRowSpan: number = isUpper ? 12 : 8;

    // 下段は「環境(実施場所、補助具など)	」が無い分「状況・生活課題」が大きい.
    const detailRowSpan: number = isUpper ? 9 : 18;

    // 起居動作と状況・生活課題は次の行がないのでborderBottomのpxを太くする.
    // タイトル名がある、かつ下段.
    const titleBottomPx: number = (titleName && isUpper === false) ? 2 : 1;

    // 項目/課題は次の行がないときはborderBottomのpxを太くする.
    const bottomPx: number = isLast ? 2 : 1;

    return (
      <tr key="sheet1">
        { titleName ? 
          <td
            style={{
            borderTop: '1px solid black',
            borderBottom: `${titleBottomPx}px solid black`,
            borderLeft: '2px solid black',
            borderRight: '1px solid black',
            textAlign: 'center', verticalAlign: 'middle'}}
            rowSpan={titleRowSpan}
            colSpan={4} 
          >
            {titleName}
          </td> : (null)
        }
        <td
          style={{height: 53,
          borderTop: '1px solid black',
          borderBottom: `${bottomPx}px solid black`,
          borderLeft: '1px solid black',
          borderRight: '1px solid black',
          textAlign: 'center', verticalAlign: 'middle'}}
          rowSpan={2}
          colSpan={4} 
        >
          {itemName}
        </td>
        <td
          style={{
          borderTop: '1px solid black',
          borderBottom: '1px solid black',
          borderLeft: '1px solid black',
          borderRight: '1px solid black',
          textAlign: 'left', verticalAlign: 'middle'}}
          colSpan={4}
        >
          {check(levels[0])} 自立
        </td>
        <td
          style={{
          borderTop: '1px solid black',
          borderBottom: '1px solid black',
          borderLeft: '1px solid black',
          borderRight: '1px solid black',
          textAlign: 'left', verticalAlign: 'middle'}}
          colSpan={4}
        >
          {check(levels[1])} 見守り
        </td>
        {/* 課題 */}
        <td
          style={{
          borderTop: '1px solid black',
          borderBottom: `${bottomPx}px solid black`,
          borderLeft: '1px solid black',
          borderRight: '1px solid black',
          textAlign: 'center', verticalAlign: 'middle'}}
          colSpan={2}
          rowSpan={2}
        >
          {problem}
        </td>
        {/* 環境(実施場所、補助具など) */}
        { isUpper ? 
          <td
            style={{
            borderTop: '1px solid black',
            borderBottom: '1px solid black',
            borderLeft: '1px solid black',
            borderRight: '1px solid black',
            padding: 5,
            textAlign: 'left', verticalAlign: 'middle'}}
            colSpan={9}
            rowSpan={2}
          >
            {env}
          </td> : (null)
        }
        {/* 状況・生活課題 */}
        { titleName ? 
          <td
            style={{
            borderTop: '1px solid black',
            borderBottom: `${titleBottomPx}px solid black`,
            borderLeft: '1px solid black',
            borderRight: '2px solid black',
            padding: 5,
            textAlign: 'left', verticalAlign: 'top'}}
            colSpan={detailRowSpan}
            rowSpan={12}
          >
            {detail}
          </td> : (null)
        }
      </tr>
    );
  }

  /**
   * 各項目のJSXの描画その2.
   * @method renderSection2
   * @param {Boolean} isLast 一番最後の行.
   * @param {Boolean[]} levels レベルの内容の配列.
   * @return {JSX.Element} JSX.
   */
  renderSection2(isLast: boolean, levels: boolean[]): JSX.Element {
    const check = (isCheck: boolean): string => {
      return isCheck ? '■' : '□';
    };

    // 最後だけ次の行がないのでborderBottomのpxを太くする.
    const bottomPx: number =  isLast ? 2 : 1;

    return (
      <tr key="sheet2">
        <td
          style={{width: 140,
          borderTop: '1px solid black',
          borderBottom: `${bottomPx}px solid black`,
          borderLeft: '1px solid black',
          borderRight: '1px solid black',
          textAlign: 'left', verticalAlign: 'middle'}}
          colSpan={4}
        >
          {check(levels[0])} 一部介助
        </td>
        <td
          style={{
          borderTop: '1px solid black',
          borderBottom: `${bottomPx}px solid black`,
          borderLeft: '1px solid black',
          borderRight: '1px solid black',
          textAlign: 'left', verticalAlign: 'middle'}}
          colSpan={4}
        >
          {check(levels[1])} 全介助
        </td>
      </tr>
    );
  }

  /**
   * 各項目のJSXの描画.
   * @method renderSection
   * @param {Boolean} isUpper 上段(true), 下段(false).
   * @param {String|Boolean} titleName 大項目名(falseなら非表示).
   * @param {String} itemName 項目タイトル名.
   * @param {HomeVisit.Multiple} multiple 連想配列.
   * @param {String|Boolean} detail 状況・生活課題(falseなら1行目ではない).
   * @return {JSX.Element[]} JSXの配列.
   */
  renderSection(isUpper: boolean, titleName: boolean|string, itemName: string, multiple: HomeVisit.Multiple,
                detail: boolean|string): JSX.Element[] {
    // multipleを分離.
    // レベルの内容の配列(自立=0、見守り=1、一部介助=2、全介助=3).
    let levels: number[] = [];
    // 課題の有無.
    let isProblem: boolean = false;
    
    // 環境(実施場所、補助具など)(falseなら下段なので非表示).
    let env: boolean|string =  false;

    if (multiple) {
      levels = multiple ? multiple.level : [];
      isProblem = multiple ? multiple.is_problem : false;
      env = (multiple.env === undefined) ? false : multiple.env;
    }

    // number[] -> boolean[]
    const levelsBools: boolean[] = Enumerable.range(0, 4).select((i: number) => {
      return (levels.indexOf(i) > -1);
    }).toArray();

    // 項目が最後.
    const isLast: boolean = itemName === '立位';

    return ([
      this.renderSection1(isLast, isUpper, titleName, itemName, [levelsBools[0], levelsBools[1]],
                          isProblem, env, detail),
      this.renderSection2(isLast, [levelsBools[2], levelsBools[3]]),
    ]);
  }

  componentWillMount() {
    // 全体のシーケンス数.
    this.total = this.props.total;
  }

  render() {
    if (this.props.moffAPI.result === undefined) {
      return (null);
    }

    this.homeVisit = this.props.moffAPI.result.homeVisit;
    this.user = this.props.moffAPI.result.user;
    this.refresh();

    return (
      <table cellSpacing="0" style={{border: 0, margin: 10, borderCollapse: 'separate'}}>
        <colgroup span={20} style={{width: 62}} />
        <colgroup style={{width: 29}} /> 
        <colgroup span={15} style={{width: 28}} />
        <tbody>
          <tr key="sheetTitle">
            <td style={{borderBottom: '1px solid black', textAlign: 'center', verticalAlign: 'middle'}} colSpan={36}>
              居宅訪問チェックシート
            </td>
          </tr>
          <tr key="sheetUser">
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '2px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={4}
            >
              利用者氏名
            </td>
            <td
              style={{border: '1px solid black', textAlign: 'center', verticalAlign: 'middle'}}
              colSpan={10}
            >
              {this.userName}
            </td>
            <td
              style={{
              border: '1px solid black', textAlign: 'center', verticalAlign: 'middle',
              backgroundColor: '#F2F2F2'}}
              colSpan={4}
            >
              生年
            </td>
            <td
              style={{width: 300, paddingLeft: 5,
              border: '1px solid black', textAlign: 'left', verticalAlign: 'middle'}}
              colSpan={9}
            >
              {this.birthYear}年
            </td>
            <td
              style={{width: '80px', paddingRight: 5,
              border: '1px solid black', textAlign: 'right', verticalAlign: 'middle', }}
              colSpan={3}
            >
              歳
            </td>
            <td
              style={{width: '100px', border: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={2}
            >
              性別
            </td>
            <td
              style={{width: '180px', 
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '1px solid black',
              borderRight: '2px solid black',
              textAlign: 'center', verticalAlign: 'middle'}}
              colSpan={4}
            >
              {this.gender === 0 ? Male : Female}
            </td>
          </tr>
          <tr key="sheetDate">
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '2px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={4} 
            >
              訪問日
            </td>
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black', 
              borderLeft: '1px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle'}}
              colSpan={23} 
            >
              {this.visitDate}
            </td>
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black', 
              borderLeft: '1px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={5} 
            >
              要介護度
            </td>
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black', 
              borderLeft: '1px solid black',
              borderRight: '2px solid black',
              textAlign: 'center', verticalAlign: 'middle'}}
              colSpan={4} 
            >
              {this.careLevel}
            </td>
          </tr>
          <tr key="sheetStaff">
            <td
              style={{width: 150,
              borderTop: '1px solid black',
              borderBottom: '1px solid black', 
              borderLeft: '2px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={4} 
            >
              訪問スタッフ
            </td>
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '1px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle'}}
              colSpan={10} 
            >
              {this.visitStaff}
            </td>
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '1px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={4}
            >
              職種
            </td>
            <td
              style={{
              width: 330,
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '1px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle'}}
              colSpan={9}
            >
              {this.profession}
            </td>
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '1px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={5}
            >
              被聞き取り者
            </td>
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '1px solid black',
              borderRight: '2px solid black',
              textAlign: 'center', verticalAlign: 'middle'}}
              colSpan={4}
            >
              {this.listenedUser}
            </td>
          </tr>
          {/* 隙間 */}
          <tr key="sheetSpace">
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              height: 10, textAlign: 'center', verticalAlign: 'middle'}}
              colSpan={36}
            />
          </tr>
          {/* 上段 */}
          <tr key="sheetUpper">
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '2px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={4} 
            />
            <td
              style={{width: 130,
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '1px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={4} 
            >
              項目
            </td>
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '1px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={8} 
            >
              レベル
            </td>
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '1px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={2}
            >
              課題
            </td>
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '1px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={9} 
            >
              環境(実施場所、補助具など)
            </td>
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '1px solid black',
              borderRight: '2px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={9} 
            >
              状況・生活課題
            </td>
          </tr>
          {/* ADL */}
          {this.renderSection(true, 'ADL', '食事', this.homeVisit.adl_feed, this.homeVisit.adl_detail)}
          {this.renderSection(true, false, '排尿', this.homeVisit.adl_ur, false)}
          {this.renderSection(true, false, '入浴', this.homeVisit.adl_bath, false)}
          {this.renderSection(true, false, '更衣', this.homeVisit.adl_dress, false)}
          {this.renderSection(true, false, '整容', this.homeVisit.adl_cosme, false)}
          {this.renderSection(true, false, '移乗', this.homeVisit.adl_transfer, false)}
          {/* IADL */}
          {this.renderSection(true, 'IADL', '屋内移動', this.homeVisit.iadl_indoor, this.homeVisit.iadl_detail)}
          {this.renderSection(true, false, '屋外移動', this.homeVisit.iadl_outdoor, false)}
          {this.renderSection(true, false, '階段昇降', this.homeVisit.iadl_lift, false)}
          {this.renderSection(true, false, '調理', this.homeVisit.iadl_cook, false)}
          {this.renderSection(true, false, '洗濯', this.homeVisit.iadl_wash, false)}
          {this.renderSection(true, false, '掃除', this.homeVisit.iadl_clean, false)}
          {/* 下段 */}
          <tr key="sheetDown">
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '2px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={4}
            />
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '1px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={4}
            > 
              項目
            </td>
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '1px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={8}
            >
              レベル
            </td>
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '1px solid black',
              borderRight: '1px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={2}
            >
              課題
            </td>
            <td
              style={{
              borderTop: '1px solid black',
              borderBottom: '1px solid black',
              borderLeft: '1px solid black',
              borderRight: '2px solid black',
              textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#F2F2F2'}}
              colSpan={18}
            >
              状況・生活課題
            </td>
          </tr>
          {/* 起居動作 */}
          {this.renderSection(false, '起居動作', '起き上がり', this.homeVisit.behaivior_arise,
                              this.homeVisit.behaivior_detail)}
          {this.renderSection(false, false, '座位', this.homeVisit.behaivior_sitting, false)}
          {this.renderSection(false, false, '立ち上がり', this.homeVisit.behaivior_standup, false)}
          {this.renderSection(false, false, '立位', this.homeVisit.behaivior_upright, false)}
        </tbody>
      </table>);
  }
}



// WEBPACK FOOTER //
// ./src/components/HomeVisitPrintBrowsers/Default.tsx